import React, { useContext, useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import AuthContext from '../../context/AuthContext';
import styles from './styles/StripeCheckout.module.css';
import { SUBSCRIPTION_PLANS } from './SubscriptionPlans';
import StripeOuter from './StripeOuter';
import axios from 'axios'
import Loading from '../loading/Loading';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function StripeCheckout() {
    const { getLoggedIn, loggedIn, user, userId } = useContext(AuthContext);
    const [clientSecret, setClientSecret] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [intentSubscriptionId, setIntentSubscriptionId] = useState(null);
    const [activePlanKey, setActivePlanKey] = useState(null);
    const [activeSubscriptionId, setActiveSubscriptionId] = useState(null); 
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                await getLoggedIn();
                console.log("doing stuff")
                const response = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/get-all-subscriptions/${userId}`);
                const subscriptions = response.data.subscriptions || [];
                
                for (const sub of subscriptions) {
                    let cancelledSubscription = sub.cancel_at_period_end;

                    const matchedEntry = Object.entries(SUBSCRIPTION_PLANS).find(
                        ([, data]) => data.priceId === sub.plan.id
                    );
                    if (matchedEntry) {
                        setActivePlanKey([matchedEntry[0], cancelledSubscription]);
                        setActiveSubscriptionId(sub.id);
                        break; 
                    }
                }

                console.log(user);
            } catch (err) {
                console.error("Failed to fetch subscriptions", err);
            } finally{
                setLoading(false);
            }
        };
        if (userId) fetchSubscriptions();
    }, [userId]);

    const handleCancelSubscription = async () => {
        console.log(user.stripeCustomerId, user.stripeSubscriptionId);
        const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/cancel-subscription/${userId}`, { subscriptionId: user.stripeSubscriptionId });
        await getLoggedIn();

        if (activePlanKey && response.data.success) {
            setActivePlanKey([activePlanKey[0], true]); 
        }

        console.log(response.data);
    }

    const handleRenewSubscription = async () => {
        const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/renew-subscription/${userId}`, { subscriptionId: activeSubscriptionId });
        await getLoggedIn();

        if (activePlanKey && response.data.success) {
            setActivePlanKey([activePlanKey[0], false]); 
        }

        console.log(response.data);
    }

    async function handleSubscribe(planKey) {
        if (!loggedIn) {
            console.error('User must be logged in to subscribe.');
            return;
        }

        const plan = SUBSCRIPTION_PLANS[planKey];
        setSelectedPlan(plan); 

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/create-subscription`, { priceId: plan.priceId, userId });
            console.log(response.data);

            if (response.data.clientSecret) {
                setClientSecret(response.data.clientSecret);
            } else {
                console.error('No clientSecret returned:', response.data);
            }
            setIntentSubscriptionId(response.data.subscriptionId);
        } catch (error) {
            console.error('Error creating subscription intent:', error);
        }
    }

    if(loading) return <Loading />;

    if (clientSecret && intentSubscriptionId) {
        return (
            <StripeOuter 
                stripePromise={stripePromise} 
                clientSecret={clientSecret} 
                selectedPlan={selectedPlan}
                subscriptionId={intentSubscriptionId}
            />
        );
    }

    return (
        // <div className={styles.container}>
        //     <h1 className={styles.header}>Choose Your Plan</h1>
        //     <div className={styles.plansContainer}>
        //         {Object.entries(SUBSCRIPTION_PLANS).map(([planKey, plan]) => (
        //             <div key={planKey} className={styles.planCard}>
        //                 <div className={styles.planContent}>
        //                     <h2 className={styles.planName}>{plan.name}</h2>
        //                     <div className={styles.price}>{plan.price}</div>
        //                     <ul className={styles.featuresList}>
        //                         {plan.features.map((feature, index) => (
        //                             <li key={index} className={styles.featureItem}>
        //                                 {feature}
        //                             </li>
        //                         ))}
        //                     </ul>
        //                     <button 
        //                         onClick={() => handleSubscribe(planKey)}
        //                         className={styles.subscribeButton}
        //                     >
        //                         Subscribe Now
        //                     </button>
        //                 </div>
        //             </div>
        //         ))}
        //     </div>
        // </div>
        <div className={styles.container}>
            <h1 className={styles.header}>Choose Your Plan</h1>
            <div className={styles.plansContainer}>
                {Object.entries(SUBSCRIPTION_PLANS).map(([planKey, plan]) => {
                    const isCurrent = planKey === (activePlanKey ? activePlanKey[0] : null);
                    const cancelled = (activePlanKey ? activePlanKey[1] : false);
                    return (
                        <div key={planKey} className={styles.planCard}>
                            <div className={styles.planContent}>
                                <h2 className={styles.planName}>{plan.name}</h2>
                                <div className={styles.price}>{plan.price}</div>
                                <ul className={styles.featuresList}>
                                    {plan.features.map((feature, index) => (
                                        <li key={index} className={styles.featureItem}>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                                {isCurrent ? (
                                    cancelled ? (
                                        <button 
                                            onClick={handleRenewSubscription}
                                            className={styles.cancelButton}
                                        >
                                            Renew Subscription
                                        </button>
                                    ) : (
                                        <button 
                                            onClick={handleCancelSubscription}
                                            className={styles.cancelButton}
                                        >
                                            Cancel Subscription
                                        </button>
                                    )
                                ) : (
                                    <button 
                                        onClick={() => handleSubscribe(planKey)}
                                        className={styles.subscribeButton}
                                    >
                                        Subscribe Now
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default StripeCheckout;
